import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  items: {},
  isLoading: false,
  error: false,

  unpaidFilter: [],
  errorUnpaidFilter: false,
  isLoadingUnpaidFilter: false,

  paymentWaiting: [],
  errorpaymentWaiting: false,
  isLoadingpaymentWaiting: false,

  paymentPartial: [],
  errorpaymentPartial: false,
  isLoadingpaymentPartial: false,

  paymentComplete: [],
  errorpaymentComplete: false,
  isLoadingpaymentComplete: false,

  errorDownloading: false,
  isDownloading: false,
  item: {},

  createPayment: {},
  errorCreatePayment: false,
  isLoadingCreatePayment: false,

  dataTemp: {},

  getPaymentDetail: {},
  errorPaymentDetail: false,
  isLoadingPaymentDetail: false,

  getPaymentHistory: {},
  errorPaymentHistory: false,
  isLoadingPaymentHistory: false,

  putPartialProof: {},
  errorPartialProof: false,
  isLoadingPartialProof: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/index.js